import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["minSize", "edgeIndent", "gutter", "minVisible", "maxVisible"];
import { times } from '@beef/utils';
var MIN_SUPPORTED_RESOLUTION = 320;
export var makeGridQueries = function makeGridQueries(id, count, _ref) {
  var minSize = _ref.minSize,
    edgeIndent = _ref.edgeIndent,
    gutter = _ref.gutter,
    minVisible = _ref.minVisible,
    maxVisible = _ref.maxVisible,
    option = _objectWithoutProperties(_ref, _excluded);
  /**
   * MinColumnSize layout:
   * | edgeSpace | minSize | gutter | minVisible * minSize |
   *
   * MaxColumnSize layout:
   * | edgeSpace | maxSize | gutter | maxVisible * minSize |
   *
   * Window width for MaxColumnSize equals MinColumnSize for same blocks + 1:
   * ------
   * | edgeSpace | minSize | gutter | minSize | gutter | minVisible * minSize |
   */
  var calcMinFitSize = function calcMinFitSize(n) {
    return edgeIndent + n * gutter + minSize * (n + minVisible);
  };
  var calcMaxSize = function calcMaxSize(n) {
    return (calcMinFitSize(n + 1) - edgeIndent - n * gutter) / (n + maxVisible);
  };
  var getMediaInterval = function getMediaInterval(min, max) {
    var minQuery = "(min-width: ".concat(min, "px)");
    var maxQuery = "(max-width: ".concat(max, "px)");
    return min !== 0 ? "".concat(minQuery, " and ").concat(maxQuery) : maxQuery;
  };

  /**
   * Рассчитываем константы по формуле для minFitSize и maxFitSize
   * blockSize = k * width + b,
   *   где k - динамический коэффициент
   *   b - константа
   *   W - разрешение экрана
   */
  var getWidthFormula = function getWidthFormula(minWidth, maxWidth, minFitSize, maxFitSize) {
    var k = (maxWidth - minWidth) / (maxFitSize - minFitSize);
    var b = minWidth - minFitSize * k;
    return "calc(".concat(Math.round(100 * k), "vw + ").concat(Math.round(b), "px)");
  };
  return ["\n      .".concat(id, " {\n        min-width: ").concat(minSize, "px;\n        max-width: ").concat(option.maxSize, "px;\n      }\n    ")].concat(_toConsumableArray(times(count - 1, function (i) {
    return i;
  }).map(function (n) {
    var minFitSize = calcMinFitSize(n);
    var maxFitSize = calcMinFitSize(n + 1);
    var maxSize = calcMaxSize(n);
    if (maxFitSize < MIN_SUPPORTED_RESOLUTION) return undefined;
    return "\n      @media ".concat(getMediaInterval(minFitSize, maxFitSize), " {\n        .").concat(id, " {\n          min-width: ").concat(getWidthFormula(minSize, maxSize, minFitSize, maxFitSize), "\n        }\n      }\n    ");
  }))).filter(Boolean);
};